<template>

	<div
		class="form-group"
		v-if="(singleBudget.status == 'Expired' && showExpired) || (singleBudget.status != 'Expired' && !showExpired)"
	>
		<div class="row" style="margin:0px" v-if="renderComponent">
			<div class="col-md-2 form-group" style="padding:3px">
				<label for="newBudget">New Budget</label>
				<input
					type="text"
					v-bind:disabled="hide"
					v-model="singleBudget.budget"
					v-on:keydown="validKey"
					v-on:click="hideEmptyBudgetSpan()"
					class="form-control"
					id="newBudget"
					placeholder="Budget"
				>
			</div>

			<div class="col-md-2 form-group" style="padding:3px">
				<label for="effectiveStartDate">Effective Start Date</label>
				<!--Max date validation :max="this.maxStartDAte" -->
				<b-form-datepicker
					:id="'effectiveStartDate'+arrIndex"
					:name="'startDate'+arrIndex"
					placeholder="MM/DD/YYYY"
					class="date_wrapper label-padding"
					v-model="singleBudget.start_date"
					menu-class="w-100"
					size="sm"
					:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
					calendar-width="200%"
					:hide-header="true"
					:today-button="false"
					:min="currDate"
					v-bind:disabled="hide"
					v-on:keydown="dontAllowManualDateEditing"
					@shown="setMinMaxStartDate();hideEmptyBudgetSpan();"
					@input="startDateValidation(true)"
					locale="en"
					v-bind:class="hide ? 'date-disabled' :''"

				>
			</b-form-datepicker>
				<!-- <input
					type="date"
					v-model="singleBudget.start_date"
					:min="this.currDate"
					v-bind:disabled="hide"
					v-on:keydown="dontAllowManualDateEditing"
					v-on:click="setMinMaxStartDate();hideEmptyBudgetSpan();"
					@change="startDateValidation(true)"
					class="form-control padding-custom"
					id="effectiveStartDate"
				> -->
				<!-- <span v-if="InvalidDateSpan" style="color:red;font-size:13px;padding:5px"> Invalid Date Range</span> -->
			</div>

			<div class="col-md-2 form-group" style="padding:3px">
				<label for="effectiveEndDate">Effective End Date</label>
				<b-form-datepicker
					:id="'effectiveEndDate'+arrIndex"
					:name="'endDate'+arrIndex"
					placeholder="MM/DD/YYYY"
					class="date_wrapper label-padding"
					v-model="singleBudget.end_date"
					menu-class="w-100"
					size="sm"
					:date-format-options="{day: '2-digit',  month: '2-digit',  year: 'numeric' }"
					calendar-width="200%"
					:hide-header="true"
					:today-button="false"
					:min="minEndDate"
					v-bind:disabled="hide || singleBudget.start_date == '' || singleBudget.start_date == null "
					v-on:keydown="dontAllowManualDateEditing"
					@input="overlappingDate()"
					locale="en"
					:class="(hide || singleBudget.start_date == '' || singleBudget.start_date == null)?'date-disabled':''"
				></b-form-datepicker>
				<!-- Max End Date :max="this.maxEndDAte" -->
				<!-- <input
				type="date"
				v-model="singleBudget.end_date"
				:min="this.minEndDate"
				v-on:keydown="dontAllowManualDateEditing"
				@change="overlappingDate()"
				v-bind:disabled="hide || this.singleBudget.start_date == ''"
				id="effectiveEndDate"
				class="form-control padding-custom"
				> -->
			</div>
			<div class="col-md-2 form-group" v-if="singleBudget.id" style="padding:3px">
				<label for="fallbackBudget">FallBack Budget</label>
				<input
					type="text"
					v-model="fallbackBudget"
					disabled="true"
					id="fallbackBudget"
					class="form-control"
				>
			</div>
			<div v-else class="col-md-2 form-group" style="padding:3px"></div>
			<div v-if="singleBudget.id" class="col-md-1 form-group" style="padding:3px">
				<label for="status">Status</label>
				<input
					type="text"
					style="padding:6px"
					v-model="singleBudget.status"
					disabled="true"
					class="form-control"
				>
			</div>
			<div v-else class="col-md-1 form-group" style="padding:3px"></div>
			<div v-show="showSaveSpinner" class="spinner-border" style="margin:35px;display:block;"></div>
			<div v-show="!showSaveSpinner" class="col-md-3" style="padding:1px;margin-top:27px;">
				<div v-if="profileId != 'null' &&  profileId != 'NullWithPrefilledVendorBrand'">
					<div style="margin-left:5px;padding:2px;" v-if="!showDelete">
						<button
							style="color:white"
							id="save"
							class="btn btn-primary"
							v-on:click="save"
							v-if="this.singleBudget.start_date != '' && this.singleBudget.budget != '' && this.showSave == true"
						>Save</button>
						<button
							style="color:white"
							id="edit"
							class="btn btn-primary"
							v-on:click="edit"
							v-if="this.showEdit && this.allowEdit"
						>Edit</button>
						<button
							style="color:white"
							id="cancel"
							class="btn btn-primary"
							v-if=" (this.showSaveCancel== true) || this.showSave == true && (this.singleBudget.end_date == '' || this.singleBudget.start_date == '' || this.singleBudget.budget == '') && this.showCancel == true "
							v-on:click="cancel"
						>Cancel</button>
						<button
							v-if="(this.showAdd && this.singleBudget.end_date != 'Invalid date' && this.singleBudget.end_date != ''  && this.singleBudget.start_date != '' && this.singleBudget.budget != '' && this.arrIndex == (this.budgetItems).length-1) || (this.budgetItems.length == 1 && this.showAdd && this.singleBudget.id && singleBudget.end_date!='Invalid date' && singleBudget.end_date!='') "
							style="color:white"
							class="btn btn-primary"
							id="add"
							v-on:click="addToArray"
						>Add</button>
					</div>
					<div style="margin-left:5px;padding:2px;" v-else>
						<button
							style="color:white;background-color:red"
							id="delete"
							class="btn btn-primary"
							v-on:click="deleteFromArray"
							v-if="this.allowEdit"
						>Delete</button>
					</div>
				</div>
			</div>
		</div>
		<DeletePopUp
			v-if="isOpenDeleteModal"
			@deleteData="deleteData"
			@hideDeleteModal="hideDeleteModal"
		/>
	</div>
</template>
<script>
	import DeletePopUp from "../delete/DeletePopUp.vue";
	var moment = require("moment");
	var numeral = require("numeral");
	const formatCurrency = require("format-currency");
	export default {
		name: "ModifyEdit",

		components: {
			DeletePopUp
		},
		props: [
			"arrIndex",
			"budgetItems",
			"singleBudget",
			"profileId",
			"amsProfileId",
			"showAdd",
			"startDateArray",
			"endDateArray",
			"allowEdit",
			"showExpired"
		],
		data() {
			return {
				//InvalidDateSpan: false,
				fallbackBudget: "0",
				showSave: true,
				showEdit: false,
				showCancel: true,
				showSaveCancel: false,
				showSaveSpinner: false,
				showDelete: false,
				flag: true,
				hide: false,
				currentDate: "",
				currDate: "",
				maxEndDate: "",
				minEndDate:"",
				maxStartDAte: "",
				isOpenDeleteModal: false,
				itemToDelId: {},
				copy: {
					id: "",
					budget: "",
					fallback_budget: "0",
					start_date: "",
					end_date: ""
				},
				renderComponent:true
			};
		},
		methods: {
			checkIfUnsaved(){
				return !this.hide
			},
			forceRerender () {
				this.renderComponent = false;
				this.$nextTick (() => {
				 this.renderComponent = true;
				});
			},
			resetModifyBudget(){
				if(!(this.showEdit && this.allowEdit)){
					this.cancel()
				}
			},
			hideEmptyBudgetSpan() {
				this.$emit("hideEmptyBudgetSpan");
			},
			validKey(event) {
				var x = event.keyCode;
				if (
					!(
						(48 <= x && x <= 57) ||
						x == 8 ||
						x == 39 ||
						x == 37 ||
						x == 190 || (x>=96 && x<= 105) || x == 110
					)
				) {
					event.preventDefault();
					this.flag = false;
				}
			},
			dontAllowManualDateEditing(event) {
				var x = event.keyCode;
				if (x) {
					event.preventDefault();
				}
			},
			deleteData() {
				this.hideDeleteModal();
				this.showSaveSpinner = true;
				let vm = this;
				let callback = () => {
					vm.showSaveSpinner = false;
				};
				this.$store
					.dispatch("accounts/deleteItemFromBudgetItem", this.itemToDelId)
					.then(response => {
						vm.$emit(
							"getAccBudgetsByProfileId",
							callback
						);
						this.$emit("showToggleButton", false);
					});
			},
			hideDeleteModal() {
				this.isOpenDeleteModal = false;
			},
			addToArray() {
				this.$emit("hideShowAdd");
				this.$emit("add");
			},
			cancel() {
				this.showCancel = false;
				this.showSaveCancel = false;
				if (!(this.budgetItems.length == 0 && !this.singleBudget.id)) {
					this.$emit("unhideShowAdd");
				}
				if (this.singleBudget.id) {
					this.showEdit = true;
					this.showSave = false;
					this.$emit("unhideShowAdd");
					this.hide = true;
					this.singleBudget.id = this.copy.id;
					this.singleBudget.budget = this.copy.budget;
					this.singleBudget.start_date = this.copy.start_date;
					this.singleBudget.end_date = this.copy.end_date;
					this.$emit("increementArrayDates", this.arrIndex);
					this.$emit("alterEdit");
				} else if (this.arrIndex == 0) {
					this.showCancel = true;
					this.$emit("delete", this.arrIndex);
				} else {
					this.$emit("delete", this.arrIndex);
				}
				this.forceRerender()
			},
			deleteFromArray() {
				var Item = { id: this.singleBudget.id };
				this.itemToDelId = Item;
				this.isOpenDeleteModal = true;
			},
			save() {
				//check if no end date, then current budget row start date should be after last value of endDateArray
				if(this.singleBudget.end_date == ''){
					//no budget saved till now
					if(this.endDateArray.length){
						let lastEndDate = this.endDateArray.slice(-1)[0]
						if(this.endDateArray.indexOf('')!=-1){
							alert('Budget with an indefinite end date is already running.')
							return;
						}
						else if(moment(this.singleBudget.start_date).isAfter(moment(lastEndDate))){

						}
						else{
							alert("Try saving it with end date. Budget for a date after " + moment(this.singleBudget.start_date).format('DD/MM/YYYY') + " is already defined");
							return;
						}
					}
				}
				this.$emit("unhideShowAdd");
				this.showSaveSpinner = true;
				this.computeStatus();
				var number = numeral(this.singleBudget.budget);

				//edit case
				if (this.singleBudget.id) {
					this.$emit("alterEdit");
					var Item = {
						ams_profile_id : this.amsProfileId,
						profile_id : this.profileId,
						id: this.singleBudget.id,
						budget: number.value(),
						fallback_budget: "0",
						start_date: this.singleBudget.start_date,
						end_date: this.singleBudget.end_date
					};
				}
				//add case
				else {
					var Item = {
						id: null,
						ams_profile_id : this.amsProfileId,
						profile_id : this.profileId,
						budget: number.value(),
						fallback_budget: 0,
						start_date: this.singleBudget.start_date,
						end_date: this.singleBudget.end_date
					};
				}
				const vm = this;
				this.$store
					.dispatch("accounts/saveAccProfileBudget", Item)
					.then(response => {
						let callback = () => {
							vm.showSaveSpinner = false;
						};
						vm.$emit(
							"getAccBudgetsByProfileId",
							callback
						);
						vm.showSave = false;
						vm.showEdit = true;
						vm.hide = true;
						vm.showSaveCancel = false;
					});
			},
			edit() {
				this.hide = false;
				this.showSave = true;
				this.showEdit = false;
				//this.showAdd = false;
				this.showSaveCancel = true;
				this.$emit("hideShowAdd");
				this.$emit("alterEdit");
				this.$emit("decreementArrayDates", this.arrIndex);
				this.startDateValidation();
				console.log(this.singleBudget.id);
			},
			setMaxDate(date) {
				if (moment().date() < 14) {
					var validDate = moment([
						moment(date).year(),
						moment(date).month()
					]);
					//
					return validDate.endOf("month").format("YYYY-MM-DD");
				} else {
					var validDate = moment([
						moment(date).year(),
						moment(date).month()
					]);
					validDate = validDate.add("months", 2);
					return validDate.subtract("days", 1).format("YYYY-MM-DD");
				}
			},
			startDateValidation(resetEndDate) {
				if (resetEndDate) {
					this.singleBudget.end_date = '';
				}
				this.minEndDate = (moment().isAfter(moment(this.singleBudget.start_date))?moment().format("YYYY-MM-DD"):moment(this.singleBudget.start_date).format("YYYY-MM-DD"))
				this.maxEndDate = this.setMaxDate(moment().format("YYYY-MM-DD"));
				this.overlappingDate()
			},
			setMinMaxStartDate() {
				//this.InvalidDateSpan = false;
				// this.currDate = moment().isAfter(
				// 	moment(this.singleBudget.start_date)
				// )
				// 	? moment(this.singleBudget.start_date).format("YYYY-MM-DD")
				// 	: moment().format("YYYY-MM-DD");
				this.currDate = moment().format("YYYY-MM-DD");
				this.maxStartDAte = this.setMaxDate(moment().format("YYYY-MM-DD"));
			},
			overlappingDate() {
				for (var i = 0; i < this.startDateArray.length; i++) {
					if (
						(new Date(this.singleBudget.start_date) >=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.start_date) <=
								new Date(this.endDateArray[i])) ||
						(new Date(this.singleBudget.start_date) >=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.end_date) <=
								new Date(this.endDateArray[i])) ||
						(new Date(this.singleBudget.end_date) >=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.end_date) <=
								new Date(this.endDateArray[i])) ||
						(new Date(this.singleBudget.start_date) <=
							new Date(this.startDateArray[i]) &&
							new Date(this.singleBudget.end_date) >=
								new Date(this.endDateArray[i]))
					) {
						//this.InvalidDateSpan = true;
						if (this.singleBudget.id) {
							this.singleBudget.start_date = this.copy.start_date;
							this.singleBudget.end_date = this.copy.end_date;
							this.minEndDate = (moment().isAfter(moment(this.singleBudget.start_date))?moment().format("YYYY-MM-DD"):moment(this.singleBudget.start_date).format("YYYY-MM-DD"))
						} else {
							this.currDate = "";
							this.maxStartDAte = "";
							this.singleBudget.start_date = "";
							this.singleBudget.end_date = "";
						}
						alert("Invalid Date Selection");
						//setTimeout(() => this.InvalidDateSpan=false, 800);
					}
					else if(this.endDateArray.indexOf('')!=-1){
						let i = this.endDateArray.indexOf('')
						if((new Date(this.singleBudget.start_date) >= new Date(this.startDateArray[i])) || (new Date(this.singleBudget.end_date) >= new Date(this.startDateArray[i]))){
							if (this.singleBudget.id) {
								this.singleBudget.start_date = this.copy.start_date;
								this.singleBudget.end_date = this.copy.end_date;
								this.minEndDate = (moment().isAfter(moment(this.singleBudget.start_date))?moment().format("YYYY-MM-DD"):moment(this.singleBudget.start_date).format("YYYY-MM-DD"))
							} else {
								this.currDate = "";
								this.maxStartDAte = "";
								this.singleBudget.start_date = "";
								this.singleBudget.end_date = "";
							}
							alert("Invalid Date Selection. Budget already defined");
						}
					}
				}
				this.forceRerender()
			},
			computeStatus() {
				if (this.singleBudget.id) {
					if (this.singleBudget.status == "Expired") {
						this.showDelete = true;
						//this.$emit("showToggleButton", true);
					}
				}
			},
			validations() {
				if (this.singleBudget.id) {
					this.showSave = false;
					this.$emit("unhideShowAdd");
					this.showEdit = true;
					this.showCancel = true;
					this.hide = true;
					this.formatNum(this.singleBudget.budget);
					this.copy.id = this.singleBudget.id;
					this.copy.budget = this.singleBudget.budget;
					this.copy.start_date = this.singleBudget.start_date;
					this.copy.end_date = this.singleBudget.end_date;
				}
			},
			formatNum(num) {
				if (this.flag == true) {
					var number = numeral(num);
					this.singleBudget.budget = formatCurrency(number.value());
					// var num = formatCurrency(number.value());
					// this.singleBudget.budget = num.slice(0, num.length - 3);
				}
			},
		},
		mounted() {
			this.validations();
			this.computeStatus();
		},
		watch: {
			// singleBudget: function() {
			// 	this.formatNum(this.singleBudget.budget);
			// }
		}
	};
</script>
<style lang="scss">
input[type="date"] {
	-moz-appearance: textfield;
}
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.padding-custom{
	padding-left: 5px !important;
	padding-right: 2px !important;
}
.date-disabled{
	background-color: #e9ecef !important;
}
.label-padding label{
	padding-left: 0px !important;
	padding-right: 0px !important
}
.label-padding{
	padding-right:0px !important;
	padding-left: 2px !important;
}
</style>
